import React from 'react';
import { useIntl } from 'react-intl';
import { StreamingTrackRow } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { formatDay, formatStreamingNumber } from '../streamingFormat';
import { streamingTotalLabels } from '../streamingTotalsMessages';
import { streamingBlockMessages as messages } from '../streamingBlockMessages';
import { streamingEarningsMessages } from '../streamingEarningsMessages';
import { MoneyList } from './MoneyList';
import { Panel } from '../../components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackHeadProps {
  track: StreamingTrackRow;
}

/** The head of a track (design d2): artwork, title, release date, ISRC and UPC, and the totals. */
const TrackHeadComponent: React.FC<TrackHeadProps> = ({ track }) => {
  const intl = useIntl();
  return (
    <>
      <div className={styles.trackHead}>
        {track.imageUrl !== null ? <img src={track.imageUrl} alt="" /> : null}
        <div>
          <h2>{track.name}</h2>
          {track.releaseDate !== null ? (
            <div className={styles.faint}>
              {intl.formatMessage(messages.trackHead, { date: formatDay(intl, track.releaseDate) })}
            </div>
          ) : null}
          {track.isrc !== null ? (
            <div className={styles.faint}>
              {track.barcode !== null
                ? intl.formatMessage(messages.trackCodes, { isrc: track.isrc, upc: track.barcode })
                : intl.formatMessage(messages.trackIsrc, { isrc: track.isrc })}
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.tiles}>
        {(['streams', 'listeners', 'saves'] as const).map((key) => (
          <Panel nested key={key} className={`${styles.tile} ${styles.tileSmall}`}>
            <span className={styles.tileLabel}>{intl.formatMessage(streamingTotalLabels[key])}</span>
            <span className={styles.tileValue}>{formatStreamingNumber(intl, track[key])}</span>
          </Panel>
        ))}
        {track.earnings !== undefined ? (
          <Panel nested className={`${styles.tile} ${styles.tileSmall}`}>
            <span className={styles.tileLabel}>{intl.formatMessage(streamingEarningsMessages.colNetEarnings)}</span>
            <span className={styles.tileValue}>
              <MoneyList amounts={track.earnings} />
            </span>
          </Panel>
        ) : null}
      </div>
    </>
  );
};

export const TrackHead = TypedMemo(TrackHeadComponent);
